export const white = '#fff';
export const black = '#000';
export const creamBackground = '#F7F5EF';
export const gray50 = '#F8F8F8';
export const gray100 = '#EFEFEF';
export const gray200 = '#E1E1E1';
export const gray300 = '#D8D7D7';
export const gray400 = '#C9C7C5';
export const gray500 = '#A6A29E';
export const gray600 = '#787471';
export const gray700 = '#5E5C59';
export const gray800 = '#4B4845';
export const gray900 = '#2D2926';
export const primary50 = '#F3E8F0';
export const primary100 = '#E5CADE';
export const primary200 = '#D49FCA';
export const primary300 = '#C177B6';
export const primary400 = '#A94E99';
export const primary500 = '#913E84';
export const primary600 = '#85356F';
export const primary700 = '#662955';
export const primary800 = '#491D3D';
export const primary900 = '#2C1125';
export const orange50 = '#FDF0ED';
export const orange100 = '#F8D3C9';
export const orange200 = '#F3B6A5';
export const orange300 = '#EB896E';
export const orange400 = '#E86C4A';
export const orange500 = '#E35129';
export const orange600 = '#C73F1A';
export const orange700 = '#902E13';
export const orange800 = '#591C0C';
export const orange900 = '#360F07';
export const cream50 = '#F1EFE5';
export const cream100 = '#E5E3D8';
export const cream200 = '#D4D2C8';
export const cream300 = '#BBB9B0';
export const cream400 = '#A3A098';
export const cream500 = '#88867F';
export const cream600 = '#716F6A';
export const cream700 = '#595753';
export const cream800 = '#41403D';
export const cream900 = '#221F1D';
export const blue50 = '#EBF1F9';
export const blue100 = '#D6E4FA';
export const blue200 = '#B6D1ED';
export const blue300 = '#8FBDE6';
export const blue400 = '#78AAE6';
export const blue500 = '#588ECC';
export const blue600 = '#4678B4';
export const blue700 = '#2D598A';
export const blue800 = '#1C416A';
export const blue900 = '#0D2B49';
export const yellow50 = '#FEF8EC';
export const yellow100 = '#FBEBC6';
export const yellow200 = '#F8DEA0';
export const yellow300 = '#F3C353';
export const yellow400 = '#E5A510';
export const yellow500 = '#BF890D';
export const yellow600 = '#996E0B';
export const yellow700 = '#725208';
export const yellow800 = '#4C3705';
export const yellow900 = '#3d2412';
export const teal50 = '#E7F3F3';
export const teal100 = '#D0E7E7';
export const teal200 = '#B2D9D9';
export const teal300 = '#96C8C8';
export const teal400 = '#45AB9C';
export const teal500 = '#30948D';
export const teal600 = '#2B7D82';
export const teal700 = '#275F63';
export const teal800 = '#234548';
export const teal900 = '#192D2F';
export const red50 = '#FDEDED';
export const red100 = '#FADBDB';
export const red200 = '#F8C5C5';
export const red300 = '#F5A3A3';
export const red400 = '#F27E7E';
export const red500 = '#F04949';
export const red600 = '#D42D2D';
export const red700 = '#A82121';
export const red800 = '#7E1616';
export const red900 = '#570C0C';
export const focusShadow = blue500;
export const blackTransparent = 'rgba(26, 33, 45, 0.6)';
//# sourceMappingURL=colors.js.map